import React from 'react';
import { connect } from 'react-redux'

import Master from '../../Components/Master';
import Dialog from '../../Components/Dialog';
import { TextFieldHelper, SelectFieldWrapperExtended } from '../../Components/Fields';
import { doPost } from '../../Redux/Actions'
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

const ENDPOINT = "mitarbeiterBankverbindung"

export const Fields = ({handleChange, name, bank, bankleitzahl, kontonummer, bic, iban}) => (
    <Grid container spacing={8}>

        <TextFieldHelper n={12} value={name} onChange={handleChange('name')} label="Name" />
        <TextFieldHelper n={12} value={bank} onChange={handleChange('bank')} label="Bankname" />
        <TextFieldHelper n={12} value={bankleitzahl} onChange={handleChange('bankleitzahl')} label="Bankleitzahl" />
        <TextFieldHelper n={12} value={kontonummer} onChange={handleChange('kontonummer')} label="Kontonummer" />
        <TextFieldHelper n={12} value={bic} onChange={handleChange('bic')} label="BIC" />
        <TextFieldHelper n={12} value={iban} onChange={handleChange('iban')} label="IBAN" />

    </Grid>
)

class NewEntry extends Master {

	state = {
		newEntry: {}
	}

    componentDidMount() {
        this.state.newEntry.mitarbeiter = {id: this.props.mitarbeiterId}
    }

    _postData = () => {
        this.state.newEntry.mitarbeiter = {id: this.props.mitarbeiterId}
        this.postData()
    }

	render() {

		var {
			handleClickOpen, dialogOpen
		} = this.props

        var {
        	newEntry
        } = this.state

		return (
			<Dialog
                title="Neue Bankverbindung"
                saveAction={this._postData}
                closeAction={handleClickOpen}
                open={dialogOpen}
             >
				<Fields handleChange={this.handleChange} {...newEntry} />
			</Dialog>
		)
	}

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doPost: (data) => dispatch(doPost(ENDPOINT, "api/generic/" + ENDPOINT, data)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewEntry);


// WEBPACK FOOTER //
// ./src/Routes/MitarbeiterBankverbindung/NewEntry.js